module.exports = __webpack_public_path__ + "img/crime-sq.8d36c4cd.svg";